<app-header></app-header>
<div class="container-fluid">
  <div class="d-flex navbar-container" *ngIf="navBarVisible">
    <div class="left-container">
      <nav class="navbar navbar-expand-md">
        <div class="navbar-nav shadow-bottom">
          <a
            *ngFor="let navItem of navList; index as i"
            [routerLink]="navItem.is_active ? navItem.screen_name : null"
            routerLinkActive="nav-link-active"
            [ngClass]="['nav-item nav-link', !navItem.is_active ? 'disabled' : '', i > 0 ? 'nav-split' : '']"
            [attr.title]="!navItem.is_active ? 'Access Restricted' : ''"
          >
            <img *ngIf="navItem['screen_icon']" class="nav-icon" [src]="navItem.screen_icon" />
            <span>{{ navItem.screen_desc }}</span>
          </a>
        </div>
      </nav>
    </div>
    <div class="right-container">
      <div class="scenario-label">Select Scenario :</div>
      <div class="shadow-bottom scenario-data" (click)="onOpenScenario()">{{ selectedScenario?.scenario_name }}</div>
      <button class="mdlz-btn-outline shadow-bottom round-button" (click)="navigatePath()" title="MDM" *ngIf="visibleMDMModule">
        <img src="assets/images/database.svg" alt="database" />
      </button>
      <!-- <button class="mdlz-btn-outline shadow-bottom round-button" (click)="op.toggle($event)" disabled="true">
        <img src="assets/images/download.svg" alt="download" />
        <p-overlayPanel #op>
          <button class="btn btn-light w-100 header-btn" (click)="onOpenDialog()">Steps Summary</button>
        </p-overlayPanel>
      </button> -->
      <button class="mdlz-btn-outline shadow-bottom round-button" (click)="op.toggle($event)" title="Download" *ngIf="visibleDataDownload">
        <img src="assets/images/download.svg" alt="download" />
        <p-overlayPanel #op>
          <div class="flex-col justify-between items-center download-option relative">
            <!-- <div *ngFor="let file of downloadFileOptions" class="flex">
              <mat-checkbox class="bottom-1.5" [(ngModel)]="file.checked" [title]="file.label"> {{ file.label }}</mat-checkbox>
            </div> -->
            <div class="flex pr-2" *ngFor="let file of downloadFileOptions" [ngClass]="{ 'blur-[1px]': showDownloadLoader }">
              <button class="btn btn-light" (click)="onDownloadData(file.fileName, op)" [disabled]="showDownloadLoader">
                <img src="assets/images/download.svg" alt="download" class="w-4 mr-1" />{{ file.label }}
              </button>
            </div>
            <span *ngIf="showDownloadLoader" class="absolute top-0 right-0 left-0 bottom-0 flex justify-center items-center">
              <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem"></i>
            </span>
          </div>
        </p-overlayPanel>
      </button>
      <button class="mdlz-btn-outline shadow-bottom round-button" (click)="userPop.toggle($event)" title="Logout">
        <img class="logout" src="assets/images/userIcon.svg" alt="user" />
        <p-overlayPanel #userPop>
          <div class="flex justify-start gap-2 pt-2">
            <img class="logout" src="assets/images/userIcon.svg" alt="user" />
            <p class="!text-lg font-bold text-center text-nowrap">{{ user?.fullname }}</p>
          </div>
          <i class="fa fa-sign-out" aria-hidden="true"></i>
          <button class="btn btn-light header-btn" (click)="onLogout()">Logout</button>
        </p-overlayPanel>
      </button>
    </div>
  </div>
  <div class="filter-container pb-2">
    <app-global-filter *ngIf="globalFilterVisible" [initiateFromDialog]="false"></app-global-filter>
  </div>
  <div class="router-outlet-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>
<!-- <div
  class="chatbot-icon-container"
  #chatIcon
  (mousedown)="startDrag($event)"
  (document:mousemove)="drag($event)"
  (document:mouseup)="endDrag($event)"
  *ngIf="showChatbot"
  (click)="openChatbot($event, true)"
> -->
<div class="chatbot-icon-container" #chatIcon (click)="openChatbot($event, true)" *ngIf="showChatbot">
  <div class="title">
    <!-- <img src="assets/images/mondelez-chat-icon-white.svg" alt="mondelezchaticon" /> -->
    <img src="assets/images/chat_icons/ai-icon-white.svg" alt="aichaticon" />
    <span>AI Chat Box</span>
  </div>

  <div class="icons-section">
    <img src="assets/images/chat_icons/maximize.svg" alt="maximize-chat-box" (click)="openChatbot($event, false)" title="open chatbot in maximized mode" />

    <i class="pi pi-angle-up" alt="minimize-chat-box" (click)="openChatbot($event, true)" title="open chatbot in minimized mode"></i>
  </div>
</div>
<app-footer></app-footer>
